var path = 'alarm/alarm-header.tpl.html';
var html = " <div translate class=tb-cell flex=30>alarm.created-time</div> <div translate class=tb-cell flex=15>alarm.originator</div> <div translate class=tb-cell flex=20>alarm.type</div> <div translate class=tb-cell flex=15>alarm.severity</div> <div translate class=tb-cell flex=20>alarm.status</div> <div translate class=tb-cell flex=15>alarm.details</div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/alarm/alarm-header.tpl.html
// module id = 1373
// module chunks = 1